import { useSelector } from 'react-redux';
import { selectM11StepCount } from '../slices/m11StepCount/m11StepCountSlice';
import { M11Step001SponsorDetailsHelperText } from '../resourceComponents/m11ReportComponents/M11Step001SponsorDetails';
import { M11Step002IdentifiersHelperText } from '../resourceComponents/m11ReportComponents/M11Step002Identifiers';
import { M11Step003TitlePageDataHelperText } from '../resourceComponents/m11ReportComponents/M11Step003TitlePageData';
import { M11Step006EligibilityHelperText } from '../resourceComponents/m11ReportComponents/M11Step006Eligibility';
import { M11Step008FirstPrimaryObjectiveHelperText } from '../resourceComponents/m11ReportComponents/M11Step008FirstPrimaryObjective';
import { M11Step011ExploratoryObjectivesHelperText } from '../resourceComponents/m11ReportComponents/M11Step011ExploratoryObjectives';
import { M11Step004AmendmentHelperText } from '../resourceComponents/m11ReportComponents/M11Step004Amendment';
import { M11Step005CreateTitlePageHelperText } from '../resourceComponents/m11ReportComponents/M11Step005CreateTitlePage';
import { M11Step015ProtocolSynopsisObjectivesHelperText } from '../resourceComponents/m11ReportComponents/M11Step015ProtocolSynopsisObjectives';
import { M11Step013EnterOverallDesignHelperText } from '../resourceComponents/m11ReportComponents/M11Step013EnterOverallDesignData';
import { M11Step014EnterOverallDesign2HelperText } from '../resourceComponents/m11ReportComponents/M11Step014EnterOverallDesignData2';
import { M11Step016OverallDesignHelperText } from '../resourceComponents/m11ReportComponents/M11Step016OverallDesign';
import { M11Step017ProtocolSynopsisHelperText } from '../resourceComponents/m11ReportComponents/M11Step017ProtocolSynopsis';
import { M11Step018ProtocolSummaryHelperText } from '../resourceComponents/m11ReportComponents/M11Step018ProtocolSummary';
import { M11Step019IntroductionHelperText } from '../resourceComponents/m11ReportComponents/M11Step019Introduction';
import { M11Step012ObjectivesAndEstimandsHelperText } from '../resourceComponents/m11ReportComponents/M11Step012ObjectivesAndEstimands';
import { M11Step020TrialDesignHelperText } from '../resourceComponents/m11ReportComponents/M11Step020TrialDesign';
import { M11Step007TrialPopulationHelperText } from '../resourceComponents/m11ReportComponents/M11Step007TrialPopulation';
import { M11Step021TrialInterventionPart1HelperText } from '../resourceComponents/m11ReportComponents/M11Step021TrialInterventionPart1';
import { M11Step022TrialInterventionPart2HelperText } from '../resourceComponents/m11ReportComponents/M11Step022TrialInterventionPart2';
import { M11Step023TrialInterventionPart3HelperText } from '../resourceComponents/m11ReportComponents/M11Step023TrialInterventionPart3';
import { M11Step024TrialInterventionPart4HelperText } from '../resourceComponents/m11ReportComponents/M11Step024TrialInterventionPart4';
import { M11Step025TrialInterventionPart5HelperText } from '../resourceComponents/m11ReportComponents/M11Step025TrialInterventionPart5';
import { M11Step026ParticipantDiscontinuationHelperText } from '../resourceComponents/m11ReportComponents/M11Step026ParticipantDiscontinuation';
import { M11Step027TrialAssessmentsPart1HelperText } from '../resourceComponents/m11ReportComponents/M11Step027TrialAssessmentsPart1';
import { M11Step028TrialAssessmentsPart2HelperText } from '../resourceComponents/m11ReportComponents/M11Step028TrialAssessmentsPart2';
import { M11Step029TrialAssessmentsPart3HelperText } from '../resourceComponents/m11ReportComponents/M11Step029TrialAssessmentsPart3';
import { M11Step030AdverseEventsDefinitionsHelperText } from '../resourceComponents/m11ReportComponents/M11Step030AdverseEventsDefinitions';
import { M11Step031AdverseEventsProceduresHelperText } from '../resourceComponents/m11ReportComponents/M11Step031AdverseEventsProcedures';
import { M11Step032CompleteAdverseEventsHelperText } from '../resourceComponents/m11ReportComponents/M11Step032CompleteAdverseEvents';
import { M11Step033StatisticsPart1HelperText } from '../resourceComponents/m11ReportComponents/M11Step033StatisticsPart1';
import { M11Step010SecondaryObjectivesHelperText } from '../resourceComponents/m11ReportComponents/M11Step010SecondaryObjectives';
import { M11Step034CompleteStatisticsHelperText } from '../resourceComponents/m11ReportComponents/M11Step034CompleteStatistics';
import { M11Step035TrialOversightPart1HelperText } from '../resourceComponents/m11ReportComponents/M11Step035TrialOversightPart1';
import { M11Step036TrialOversightPart2HelperText } from '../resourceComponents/m11ReportComponents/M11Step036TrialOversightPart2';
import { M11Step037CompleteTrialOversightHelperText } from '../resourceComponents/m11ReportComponents/M11Step037CompleteTrialOversight';
import { M11Step038GatherAppendicesHelperText } from '../resourceComponents/m11ReportComponents/M11Step038GatherAppendices';
import { M11Step039GlossaryHelperText } from '../resourceComponents/m11ReportComponents/M11Step039Glossary';
import { M11Step040ReferencesHelperText } from '../resourceComponents/m11ReportComponents/M11Step040References';
import { M11Step041SupportingDetailsPart1HelperText } from '../resourceComponents/m11ReportComponents/M11Step041SupportingDetailsPart1';
import { M11Step042PriorProtocolAmendmentsHelperText } from '../resourceComponents/m11ReportComponents/M11Step042PriorProtocolAmendments';
import { M11Step043AdditionalAppendicesHelperText } from '../resourceComponents/m11ReportComponents/M11Step043AddittionalAppendices';
import { M11Step044ReportValidationHelperText } from '../resourceComponents/m11ReportComponents/M11Step044ReportValidation';
import { M11Step009OtherPrimaryObjectivesHelperText } from '../resourceComponents/m11ReportComponents/M11Step009OtherPrimaryObjectives';
import { M11Step045CreateM11ReportHelperText } from '../resourceComponents/m11ReportComponents/M11Step045CreateM11Report';

const M11HelperTextList = [
  M11Step001SponsorDetailsHelperText,
  M11Step002IdentifiersHelperText,
  M11Step003TitlePageDataHelperText,
  M11Step004AmendmentHelperText,
  M11Step005CreateTitlePageHelperText,
  M11Step006EligibilityHelperText,
  M11Step007TrialPopulationHelperText,
  M11Step008FirstPrimaryObjectiveHelperText,
  M11Step009OtherPrimaryObjectivesHelperText,
  M11Step010SecondaryObjectivesHelperText,
  M11Step011ExploratoryObjectivesHelperText,
  M11Step012ObjectivesAndEstimandsHelperText,
  M11Step013EnterOverallDesignHelperText,
  M11Step014EnterOverallDesign2HelperText,
  M11Step015ProtocolSynopsisObjectivesHelperText,
  M11Step016OverallDesignHelperText,
  M11Step017ProtocolSynopsisHelperText,
  M11Step018ProtocolSummaryHelperText,
  M11Step019IntroductionHelperText,
  M11Step020TrialDesignHelperText,
  M11Step021TrialInterventionPart1HelperText,
  M11Step022TrialInterventionPart2HelperText,
  M11Step023TrialInterventionPart3HelperText,
  M11Step024TrialInterventionPart4HelperText,
  M11Step025TrialInterventionPart5HelperText,
  M11Step026ParticipantDiscontinuationHelperText,
  M11Step027TrialAssessmentsPart1HelperText,
  M11Step028TrialAssessmentsPart2HelperText,
  M11Step029TrialAssessmentsPart3HelperText,
  M11Step030AdverseEventsDefinitionsHelperText,
  M11Step031AdverseEventsProceduresHelperText,
  M11Step032CompleteAdverseEventsHelperText,
  M11Step033StatisticsPart1HelperText,
  M11Step034CompleteStatisticsHelperText,
  M11Step035TrialOversightPart1HelperText,
  M11Step036TrialOversightPart2HelperText,
  M11Step037CompleteTrialOversightHelperText,
  M11Step038GatherAppendicesHelperText,
  M11Step039GlossaryHelperText,
  M11Step040ReferencesHelperText,
  M11Step041SupportingDetailsPart1HelperText,
  M11Step042PriorProtocolAmendmentsHelperText,
  M11Step043AdditionalAppendicesHelperText,
  M11Step044ReportValidationHelperText,
  M11Step045CreateM11ReportHelperText
];

const m11HelperTextListLength = M11HelperTextList.length;

const M11HelperText = ({ sample }) => {

  const stepCount = useSelector(selectM11StepCount);

  return <div>
    {sample ?
      <h3>M11 Report Authoring Tool (Test Drive Version) Helper Series</h3>
      :
      <h3>M11 Report Authoring Tool (Professional Version) Helper Series</h3>
    }
    <p>Step {stepCount} of {M11HelperTextList.length}</p>
    {M11HelperTextList[stepCount - 1]}
    <p>Step {stepCount} of {M11HelperTextList.length}</p>
  </div>;
};

export default M11HelperText;
export { m11HelperTextListLength };